
import { RSAA } from 'redux-api-middleware';
import config from 'config';

export const updateCustomerList = (pageSize, page, sorted, filtered) => {

  return {
   
    [RSAA]: {
      endpoint: `${config.apiRoot}/customers/list`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ pageSize, page, sorted, filtered }),
      types: [
        {
          type: 'UPDATE_CUSTOMER_LIST_REQUEST',
          payload: { listState: { pageSize, page, sorted, filtered} }
        },
        'UPDATE_CUSTOMER_LIST_SUCCESS',
        'UPDATE_CUSTOMER_LIST_FAILURE'
      ]
    }
  };
};


export const updateUserIndexOnList = (index) => {
  return {
    type: "UPDATE_CUSTOMER_INDEX_ON_LIST",
    indexOnList: index
  }

};
export const resetError = () => {
  return {
    type: "RESET_ERROR_MESSAGE_CUSTOMER_LIST"
  }
};
